/* FF360 v1.11 - Size & flavour picker across separate listings (no product data changes).
   FF360 lists every size/flavour as its own product, e.g.
     WELLCORE CREATINE MONOHYDRATE 307 GM KIWI KICK
     WELLCORE CREATINE MONOHYDRATE 122 GM TROPICAL TANGO
   This reads "<product name> <size> <flavour>" from each title, groups listings that share a
   product name, and then:
     - product page: shows Size and Flavour buttons; picking one opens that listing
     - product rows / collection grids: shows ONE card per product, with "3 sizes · 4 flavours"
   Each listing keeps its own page, GoFrugal SKU, price and stock. */
(function () {
  'use strict';

  var CACHE_KEY = 'ff360-variant-index-v1';
  var CACHE_MS = 15 * 60 * 1000;
  var SIZE_RE = /\b(\d+(?:\.\d+)?)\s*(KG|KGS|GM|GMS|G|LBS|LB|ML|LTR|L|TABLETS|TABLET|TABS|SOFTGELS|SOFTGEL|CAPSULES|CAPSULE|CAPS|SERVINGS|SERV)\b/i;
  var TO_G = { KG: 1000, KGS: 1000, GM: 1, GMS: 1, G: 1, LBS: 453.6, LB: 453.6, ML: 1, LTR: 1000, L: 1000 };

  function titleCase(s) {
    return s.toLowerCase().replace(/(^|[\s\-(&\/])([a-z])/g, function (m, p, c) { return p + c.toUpperCase(); });
  }

  function parse(p) {
    var t = (p.title || '').replace(/\s+/g, ' ').trim();
    var m = t.match(SIZE_RE);
    if (!m) return null;
    var base = t.slice(0, m.index).trim();
    if (!base) return null;
    var unit = m[2].toUpperCase();
    var num = parseFloat(m[1]);
    var flavour = t.slice(m.index + m[0].length).trim().replace(/^[-–,]\s*/, '');
    var unitLabel = { KG: 'kg', KGS: 'kg', GM: 'g', GMS: 'g', G: 'g', LBS: 'lb', LB: 'lb', ML: 'ml', LTR: 'L', L: 'L' }[unit] || titleCase(unit);
    var v = (p.variants && p.variants[0]) || {};
    return {
      handle: p.handle,
      base: base,
      key: base.toUpperCase(),
      size: num + ' ' + unitLabel,
      sizeSort: TO_G[unit] ? num * TO_G[unit] : num,
      flavour: flavour ? titleCase(flavour) : '',
      available: p.variants ? p.variants.some(function (x) { return x.available; }) : true,
      price: v.price
    };
  }

  function buildIndex(products) {
    var byHandle = {}, groups = {};
    products.forEach(function (p) {
      var r = parse(p);
      if (!r) return;
      byHandle[r.handle] = r;
      (groups[r.key] = groups[r.key] || []).push(r);
    });
    Object.keys(groups).forEach(function (k) { if (groups[k].length < 2) delete groups[k]; });
    return { byHandle: byHandle, groups: groups };
  }

  function loadProducts() {
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && Date.now() - c.t < CACHE_MS) return Promise.resolve(c.p);
    } catch (e) {}
    var all = [];
    function page(n) {
      return fetch('/products.json?limit=250&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) {
          var ps = (j.products || []).map(function (p) {
            return { handle: p.handle, title: p.title, variants: (p.variants || []).map(function (v) { return { available: v.available, price: v.price }; }) };
          });
          all = all.concat(ps);
          return ps.length === 250 && n < 20 ? page(n + 1) : all;
        });
    }
    return page(1).then(function (p) {
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), p: p })); } catch (e) {}
      return p;
    });
  }

  function uniq(arr) { var s = {}; return arr.filter(function (x) { if (s[x]) return false; s[x] = 1; return true; }); }

  /* ---------------- Product page picker ---------------- */
  function productPicker(idx) {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var me = idx.byHandle[decodeURIComponent(m[1])];
    if (!me || !idx.groups[me.key]) return;
    var info = document.querySelector('.shopify-section--main-product .product-info, main .product-info');
    if (!info || info.querySelector('.ffv')) return;
    var group = idx.groups[me.key];

    var sizes = uniq(group.slice().sort(function (a, b) { return a.sizeSort - b.sizeSort; }).map(function (g) { return g.size; }));
    var flavours = uniq(group.map(function (g) { return g.flavour; }).filter(Boolean)).sort();

    function find(size, flavour) {
      return group.filter(function (g) { return g.size === size && g.flavour === flavour; })[0];
    }
    function bestFor(field, value) {
      var other = field === 'size' ? 'flavour' : 'size';
      var exact = group.filter(function (g) { return g[field] === value && g[other] === me[other]; })[0];
      if (exact) return exact;
      var avail = group.filter(function (g) { return g[field] === value && g.available; })[0];
      return avail || group.filter(function (g) { return g[field] === value; })[0];
    }

    function row(label, field, values, current) {
      if (values.length < 2) return '';
      var html = '<div class="ffv__row"><p class="ffv__label">' + label + ': <strong>' + (current || '-') + '</strong></p><div class="ffv__opts" role="radiogroup" aria-label="' + label + '">';
      values.forEach(function (val) {
        var target = bestFor(field, val);
        var combo = field === 'size' ? find(val, me.flavour) : find(me.size, val);
        var cls = 'ffv__opt';
        if (val === current) cls += ' is-on';
        if (!combo) cls += ' is-other';                       // exists, but not with the current other choice
        else if (!combo.available) cls += ' is-out';          // exists but sold out
        html += '<a class="' + cls + '" role="radio" aria-checked="' + (val === current) + '" href="/products/' + target.handle + '" data-ffv>' + val + '</a>';
      });
      return html + '</div></div>';
    }

    var html = row('Size', 'size', sizes, me.size) + row('Flavour', 'flavour', flavours, me.flavour);
    if (!html) return;
    var box = document.createElement('div');
    box.className = 'ffv';
    box.innerHTML = html;

    var anchor = info.querySelector('[data-block-type="price"]') || info.querySelector('[data-block-type="title"]');
    var item = anchor && anchor.closest('.product-info__block-item, .product-info__block-group');
    if (item && item.parentNode) item.parentNode.insertBefore(box, item.nextSibling);
    else info.prepend(box);
  }

  /* ---------------- One card per product in rows and grids ---------------- */
  function cardWrap(card) {
    var p = card.parentElement;
    return p && p.classList.contains('ffx-rail__item') ? p : card;
  }
  function summary(group) {
    var s = uniq(group.map(function (g) { return g.size; })).length;
    var f = uniq(group.map(function (g) { return g.flavour; }).filter(Boolean)).length;
    var parts = [];
    if (s > 1) parts.push(s + ' sizes');
    if (f > 1) parts.push(f + ' flavours');
    return parts.join(' · ');
  }

  function dedupe(idx, root) {
    var containers = (root || document).querySelectorAll('product-list, .product-list, .ffx-rail__track');
    containers.forEach(function (list) {
      var cards = Array.prototype.slice.call(list.querySelectorAll('product-card[handle]'));
      var keep = {};
      cards.forEach(function (card) {
        var r = idx.byHandle[card.getAttribute('handle')];
        if (!r || !idx.groups[r.key]) return;
        var k = r.key, cur = keep[k];
        // keep the first in-stock listing of each product; hide the rest
        if (!cur || (!cur.r.available && r.available)) {
          if (cur) cardWrap(cur.card).setAttribute('data-ffv-hidden', '');
          keep[k] = { card: card, r: r };
          cardWrap(card).removeAttribute('data-ffv-hidden');
        } else {
          cardWrap(card).setAttribute('data-ffv-hidden', '');
        }
      });
      Object.keys(keep).forEach(function (k) {
        var card = keep[k].card;
        if (card.querySelector('.ffv-more')) return;
        var title = card.querySelector('.product-title');
        if (title) title.textContent = keep[k].r.base;
        var label = summary(idx.groups[k]);
        if (!label) return;
        var tag = document.createElement('p');
        tag.className = 'ffv-more';
        tag.textContent = label;
        var info = card.querySelector('.product-card__info .v-stack') || card.querySelector('.product-card__info');
        if (info) info.appendChild(tag);
      });
    });
  }

  function start(idx) {
    try { productPicker(idx); } catch (e) {}
    try { dedupe(idx); } catch (e) {}
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { try { dedupe(idx); productPicker(idx); } catch (e) {} }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    loadProducts().then(buildIndex).then(start).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
